import { useGraphPropContext } from "../GraphPropsContext"
import { Line, Text } from "react-konva"
import React from "react"
import { GraphNodeProps } from "../Types"
import { positionFromCenter } from "../../util/fivell_utils"
import _ from "lodash"

export const FiveLLNode: React.FC<GraphNodeProps> = ({ value, hideLabel = false }) => {
  const { lm, pmax } = useGraphPropContext()
  const iconR = lm * 0.1

  if (value.length < 5) {
    console.error("Wrong value:", value)
    return null
  }
  const points = _(value)
    .map((v, i) => positionFromCenter(lm, (v / 12) * (lm * pmax), i))
    .flatten()
    .value()

  return (
    <>
      <Line points={points} closed stroke="#e7252D" strokeWidth={2} />
      {!hideLabel &&
        value.map((v, i) => {
          const rmax = lm * pmax
          const cpr = rmax + iconR * 2
          const [x, y] = positionFromCenter(lm, cpr, i)
          const dimension = { x: x - iconR * 3, y: y, width: iconR * 6, height: lm * 0.08 * 2.4 }
          return (
            <Text
              key={i}
              text={v + ""}
              offsetY={cpr * 0.05}
              {...dimension}
              align="center"
              // verticalAlign="middle"
              fill="#fff"
              fontSize={Math.ceil(lm * 0.1)}
              fontStyle="bold"
            />
          )
        })}
    </>
  )
}
